import React from 'react';
import './Banner.sass';
import { SubscribeModal } from '../';

class Banner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      open: false,
      bannerHeight: 0,
    }

    this.modalStatus = this.modalStatus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    const bannerId = this.props.id ? this.props.id : 66;

    const Banner = window.sessionStorage.getItem(`bcaribe-${bannerId}`);
    if (Banner) {
      this.setState({
        data: JSON.parse(window.sessionStorage.getItem(`bcaribe-${bannerId}`))
      });
    } else {
      fetch(`${process.env.REACT_APP_URL}/banner-home/${bannerId}`)
      .then(res => res.json())
      .then((res) => {
          this.setLocalStorage(res, bannerId);
        }
      )
    }

    this.setState({
      bannerHeight: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) * 38 / 100
    })

    window.addEventListener('resize', this.handleResize);
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentDidUpdate() {
    const btnAction = document.getElementById('btnModalStatus');
    if (btnAction) {
      btnAction.addEventListener('click', this.modalStatus, false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener("keydown", this.handleKeyDown, false);
    const btnModalStatus = document.getElementById('btnModalStatus');
    if (btnModalStatus) {
      document.getElementById('btnModalStatus').removeEventListener('click', this.modalStatus, false);
    }
  }

  setLocalStorage(banner, id) {
    try {
      window.sessionStorage.setItem(`bcaribe-${id}`, JSON.stringify(banner));
      this.setState({
        data: banner
      });
    } catch (error) {
      console.error(error);
    }
    return;
  }

  modalStatus() {
    this.setState({
      open: !this.state.open
    });
  }

  handleKeyDown(e) {
    if (e.keyCode === 27) {
      this.setState({
        open: false
      })
    }
  };

  handleResize() {
    this.setState({
      bannerHeight: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) * 38 / 100
    })
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-xs-12 banner" style={{height: this.state.bannerHeight}}>
            <aside>
              {this.state.data.enlace_es ?
                <a href={this.state.data.enlace_es} title="La Leyenda del Caribe"> 
                  <img className="img-responsive" src={`https://legendofeldorado.com/2018/en/img/banner/${this.state.data.foto_es}`} alt="La Leyenda del Caribe" />
                </a> : 
                <img className="img-responsive" src={`https://legendofeldorado.com/2018/en/img/banner/${this.state.data.foto_es}`} alt="La Leyenda del Caribe" />
              }
              <div className="banner__actions">
                <figure>
                  <img src="https://legendofeldorado.com/2018/en/img/caribe_logo.png" alt="La Leyenda del Caribe"/>
                </figure>

                <div
                  dangerouslySetInnerHTML={{ __html: this.state.data.content_es }}
                />

              </div>
            </aside>
          </div>
        </div>
        {this.state.open &&
          <SubscribeModal close={this.modalStatus}/>
        }
      </>
    ) 
  }
}

export default Banner;
